import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useSite } from '@/hooks/use-sites';

export const Route = createFileRoute('/_authenticated/sites/$siteId')({
  component: SiteLayout,
});

function SiteLayout() {
  const { siteId } = Route.useParams();
  const { data, isLoading, error } = useSite(siteId);

  if (isLoading) {
    return <div className="mx-auto max-w-7xl px-6 py-8 text-sm text-text-muted">Loading site…</div>;
  }
  if (error || !data) {
    return (
      <div className="mx-auto max-w-7xl px-6 py-8">
        <h2 className="text-xl font-semibold">Site not found</h2>
        <p className="mt-2 text-sm text-text-muted">It may have been archived or you don't have access.</p>
      </div>
    );
  }

  return <Outlet />;
}
